import { FC } from 'react';
import { IconSettings } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import { SimpleGrid } from '@mantine/core';

import { CardContainer } from '../../cardContainer';
import { ModuleItem } from '../../moduleItem';
import { ROUTES } from '@/containers/routes/constants';

import calendarIcon from '@assets/icon-calendar.svg';
import drawIcon from '@assets/icon-draw.svg';
import mailIcon from '@/assets/icon-mail.svg';
import contactsIcon from '@assets/icon-contacts.svg';
import projectsIcon from '@assets/icon-projects.svg';
import pagesIcon from '@assets/icon-pages.svg';
import formsIcon from '@assets/icon-forms.svg';

export interface IModuleItem {
  label: string;
  icon: string;
  link: string;
}

interface IModulesSectionProps {
  filialId?: number;
}

export const ModulesSection: FC<IModulesSectionProps> = ({ filialId }) => {
  const { t } = useTranslation();

  const modulesMenu: IModuleItem[] = [
    {
      label: t('filials.mail'),
      icon: mailIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.email}`
    },
    {
      label: t('filials.calendar'),
      icon: calendarIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.calendar}`
    },
    {
      label: t('filials.draw'),
      icon: drawIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.draw}`
    },
    {
      label: t('filials.contacts'),
      icon: contactsIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.contacts}`
    },
    {
      label: t('filials.projects'),
      icon: projectsIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.projects}`
    },
    {
      label: t('filials.pages'),
      icon: pagesIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.pages}`
    },
    {
      label: t('filials.forms'),
      icon: formsIcon,
      link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.modules.forms}`
    }
  ];

  return (
    <CardContainer sectionName={t('filials.modules.config')} Icon={IconSettings}>
      <SimpleGrid cols={2} spacing="0">
        {modulesMenu.map((item, index) => (
          <ModuleItem item={item} key={index} />
        ))}
      </SimpleGrid>
    </CardContainer>
  );
};
